import {isNil} from 'lodash'

export const nonNull = (value) => {
  return !isNil(value)
}